import React from 'react';

const ButtonClose = ({ label = 'Close', onClick, size = 12, ...rest }) => (React.createElement("button", { onClick: onClick, "aria-label": label, className: "px-2 duration-150 hover:opacity-50", ...rest },
    React.createElement("img", { src: "/close.svg", alt: "", height: size, width: size })));

export { ButtonClose };
//# sourceMappingURL=ButtonClose.js.map
